/**
 * Read-only display of a proposal line description.
 *
 * Descriptions are plain text that may contain intentional line breaks
 * (typed in the builder's multiline field). `whitespace-pre-wrap` shows
 * those breaks as real lines while still wrapping long text; React escapes
 * the text, so nothing is parsed as markup and no literal "\n" appears.
 */
export const LINE_DESCRIPTION_CLASS = "whitespace-pre-wrap break-words";

export default function LineDescription({ text, className = "", ...props }) {
  return (
    <span className={`${LINE_DESCRIPTION_CLASS} ${className}`.trim()} {...props}>
      {text}
    </span>
  );
}
